module.exports = __webpack_public_path__ + "static/media/house_medium.54017f0d.png";